import { httpResource } from 'core/resources/httpResource';
import { BaseRestResource } from '@snap-alex/domain-js';
import { userResourceUrl } from '../constants';

export class UserResource extends BaseRestResource {}

export const userResource = new UserResource(httpResource, userResourceUrl);
